<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title">
                    <router-link to="/admin/role" size="sm" class="" title="Phân quyền Workspace">
                        <i class="fa-solid fa-arrow-left"></i>
                    </router-link>
                </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button>

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        <TheSelect title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div>
                    <div class="col-md-6 text-center">
                        <button type="button" class="btn btn-success" @click="showConfirmModal()" :disabled="submitted">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Cập nhật dữ liệu
                        </button>
                    </div>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th>Menu</th>
                                <th class="col5">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                            @click="selectAllRows($event)">
                                        <label for="checkboxAll" class="custom-control-label"></label>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="vertical-align: middle !important;">{{ item.rowNumber }}</td>
                                <td style="vertical-align: middle;">{{ item.menuName }}</td>
                                <td @click="selectRow(item.id)" style="cursor: pointer; vertical-align: middle;" title="Chọn item">
                                    <span v-if="(selected.includes(item.id))" aria-hidden="true" class="text-primary">&check;</span>
                                    <span v-else aria-hidden="true">&nbsp;</span>
                                </td>
                                <!-- <td>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" name="menuIds" class="custom-control-input" v-bind:value="item.id" v-bind:id="item.id" :checked="storedMenuIds.includes(item.id)" @change="onCheck($event, item)">
                                        <label class="custom-control-label" v-bind:for="item.id"></label>
                                    </div>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CONFIRM MODAL -->
        <div class="modal fade" id="confirmModal" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xác nhận</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideConfirmModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Lưu lại thay đổi?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideConfirmModal()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-success pull-right" @click="onSubmit();" :disabled="submitted">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Đồng ý
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';
export default {
    components: {
        paginate: Paginate,
        loading: Loading,
        TheSelect
    },
    name: "TheReport",
    data() {
        return {
            isBusy: false,
            streamFileUrl: `${process.env.VUE_APP_API_URL}/Common/StreamFile?url=`,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "createdDate",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,
            storedMenuIds: [],
            deleteMenuIds: [],
            createMenuIds: [],

            // For mesage validate
            errors: {},
            submitted: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('menu', ['getAllPagingMenu']),
        ...mapActions('roleMenu', ['getByRoleIdAndMenuIds', 'createRoleMenuMultiple', 'deleteByRoleIdAndMenuIds']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Phân quyền Menu';
            this.setupHeader({ header });      
        },

        // ------ get data datatable ------
        async getData() {
            // state for loading overlay
            this.isBusy = true;
            // Set param for paging
            let params = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchKey: this.filter
            };

            // Call get data
            let res1 = await this.getAllPagingMenu(params);


            if(res1.isOk) {
                // get role menu by role id and menu ids
                let roleId = this.$route.query.id;
                let menuIds = await Promise.all(res1.data.data.map(e => e.id));
                let res2 = await this.getByRoleIdAndMenuIds({
                    roleId: roleId,
                    menuIds: menuIds
                });
                if(res2.isOk) {
                    res2.data.data.forEach(e => {
                        this.storedMenuIds.push(e.menuId);
                        this.selected.push(e.menuId);
                    });
                }

                // List data
                this.items = res1.data.data;
                // Total row
                this.totalRow = res1.data.totalRow;
                // Number show
                this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
            }

            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },

        // function select item in table
        async selectRow(id) {
            if (this.selected.includes(id)) {
                // this.selected.splice(this.selected.indexOf(id), 1);
                this.selected = this.selected.filter(e => e !== id);
            }
            else {
                this.selected.push(id);
            }
            this.createMenuIds = this.selected.filter(e => !this.storedMenuIds.includes(e));
            this.deleteMenuIds = this.storedMenuIds.filter(e => !this.selected.includes(e));
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.selected = this.items.map((item) =>  item.id);
            }
            else {
                this.selected = [];
            }
            this.createMenuIds = this.selected.filter(e => !this.storedMenuIds.includes(e));
            this.deleteMenuIds = this.storedMenuIds.filter(e => !this.selected.includes(e));
        },

        // ------ show/hide delete confirm ------
        async showConfirmModal(id) {
            this.selectedId = id;
            $('#confirmModal').modal('show');
        },
        async hideConfirmModal() {
            $('#confirmModal').modal('hide'); 
        },
        

        // ------ create, update submit ------
        async onSubmit() {
            this.submitted = true;

            // delete data
            await this.deleteByRoleIdAndMenuIds({
                roleId: this.$route.query.id,
                menuIds: this.deleteMenuIds
            });

            await this.createRoleMenuMultiple({
                roleId: this.$route.query.id,
                menuIds: this.createMenuIds
            });
            
            window.location.reload();

            //this.hideConfirmModal();
            //this.submitted = false;
        },

        
    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
    },
    async created() {

    }
}
</script>

<style>

</style>
